import type { PayloadAction } from '@reduxjs/toolkit'
import { signUpCodes, signUpCodesDetails } from 'redux/redux-modules'
import type { NormalisedSignupCodesResponse } from 'redux/redux-modules/v4/signup-codes/signup-codes.module.types'
import type { SagaIterator } from 'redux-saga'
import { put, select } from 'redux-saga/effects'

import type {
  NormalisedCombinedSignupCodeDetails,
  NormalisedSignupCodeDetails,
  NormalisedVolunteerGroup,
} from '../signup-codes-details.module.types'

export const getVolunteerGroupName = (volunteerGroups: NormalisedVolunteerGroup[]): string =>
  volunteerGroups.length
    ? (volunteerGroups.find((group) => !group.default)?.name ?? volunteerGroups[0].name)
    : ''

export function* signupCodesDetailsSetDataSaga(
  action: PayloadAction<NormalisedSignupCodeDetails>,
): SagaIterator {
  const codes: NormalisedSignupCodesResponse | null = yield select(
    signUpCodes.selectors.dataSelector,
  )

  if (codes) {
    const pathSegments = window.location.pathname.split('/')
    const codeId = pathSegments[pathSegments.length - 1]

    const matchingCode = codes.codes.find((code) => code.code === codeId)

    if (matchingCode) {
      const combinedCodeDetails: NormalisedCombinedSignupCodeDetails = {
        ...action.payload,
        ...matchingCode,
        timesUsed: action.payload.sessions.length,
      }

      yield put(signUpCodesDetails.actions.setExtendedState(combinedCodeDetails))
    }
  }

  return []
}
